var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textBoxesContainer"},_vm._l((this.loadedPage.objects.textBoxes),function(textBox,index){return _c('text-box',{key:'text-box-' + index,attrs:{"id":index},on:{"pointerdown":_vm.stopPropagation,"pointermove":_vm.stopPropagation,"pointerup":_vm.stopPropagation,"pointerleave":_vm.stopPropagation}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }